import { createContext } from 'react';
import type { ClubBranding } from './applyClubTheme';

export type ColourScheme = 'light' | 'dark';

export interface ThemeContextValue {
  branding: ClubBranding | null;
  scheme: ColourScheme;
  toggleScheme: () => void;
  refreshBranding: () => Promise<void>;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
